// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1uigU","filesListContainer":"PosDisputesFiles_filesListContainer__31oHn","filesButton":"PosDisputesFiles_filesButton__3qQ8T"};